import { render } from "./TertiaryInsurance.vue?vue&type=template&id=703b3eb6"
import script from "./TertiaryInsurance.vue?vue&type=script&lang=js"
export * from "./TertiaryInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/billingInfo/forms/TertiaryInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "703b3eb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('703b3eb6', __exports__)) {
    console.log('reload')
    api.reload('703b3eb6', __exports__)
  }
  
  module.hot.accept("./TertiaryInsurance.vue?vue&type=template&id=703b3eb6", () => {
    console.log('re-render')
    api.rerender('703b3eb6', render)
  })

}


export default __exports__